<template lang="html">
  <div class="chat" :class="{ 'chat--padding': padding }">
    <div class="chat__box">
      <div ref="chat-messages" class="container column justify-end chat__box__messages">
        <chat-message
          v-for="(message, index) in messages"
          :key="`${message._id}-${index}`"
          :myself="person"
          :message="message"
        />
      </div>
      <form class="container chat__box__form" @submit.prevent="send()" v-if="!recording">
        <textarea
          ref="message-area"
          name="message"
          class="input"
          v-model="messageText"
          @keyup.enter="handleEnter"
          autofocus
        />
        <button type="submit" name="send" class="btn btn-blue btn-rounded" v-if="!canRecord">
          <font-awesome-icon icon="paper-plane"/>
        </button>
        <button type="button" name="record" class="btn btn-blue btn-rounded" @click.prevent="record()" v-else>
          <font-awesome-icon icon="microphone"/>
        </button>
      </form>
      <div class="container chat__box__form" v-else>
        <button type="button" name="cancel-record" class="btn btn-red btn-rounded chat__box__form__cancel" @click.prevent="cancelRecord()">
          <font-awesome-icon icon="times"/>
        </button>
        <span class="flex">{{ recordTime }}</span>
        <button type="button" name="send-record" class="btn btn-blue btn-rounded" @click.prevent="sendRecord()">
          <font-awesome-icon icon="paper-plane"/>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import ChatMessage from './ChatMessage'

export default {
  name: 'chat-box',
  data () {
    return {
      messageText: '',
      recording: false,
      sentByMe: false,
      recordStart: 0,
      recordEnd: 0,
      recordInterval: null
    }
  },
  props: {
    chat: {
      type: Array,
      required: true
    },
    person: {
      type: String,
      required: true
    },
    sendMessage: {
      type: Function,
      required: true
    },
    padding: {
      type: Boolean,
      default: false
    },
    hasStream: {
      type: Boolean,
      required: true
    },
    muted: {
      type: Boolean,
      default: false
    },
    startRecording: {
      type: Function,
      default: () => false
    },
    stopRecording: {
      type: Function,
      default: () => {}
    },
    cancelRecording: {
      type: Function,
      default: () => {}
    }
  },
  computed: {
    messages () {
      return this.chat
                  .sort((a, b) => a.created_at - b.created_at)
                  .map((m, index, array) => {
                    if (index == 0)
                        return m

                      return {
                        ...m,
                        hide_name: array[index - 1]._id == m._id
                      }
                  })
    },
    canRecord () {
      return this.hasStream && !this.messageText && this.muted
    },
    recordTime () {
      const dateObj = new Date(this.recordEnd - this.recordStart)

      return `${this.formatNumber(dateObj.getUTCMinutes())}:${this.formatNumber(dateObj.getUTCSeconds())}`
    }
  },
  components: {
    [ChatMessage.name]: ChatMessage
  },
  methods: {
    send () {
      const success = this.sendMessage(this.messageText)

      if (success) {
        this.sentByMe = true
        this.messageText = ''
        this.$refs['message-area'].focus()
      }
    },
    handleEnter (event) {
      if (!event.shiftKey) {
        this.send()
      }
    },
    record () {
      this.recording = this.startRecording()

      if (this.recording) {
        this.recordEnd = Date.now()
        this.recordStart = Date.now()

        this.recordInterval = setInterval(() => {
          this.recordEnd = Date.now()
        }, 1000)
      }
    },
    sendRecord () {
      this.stopRecording((this.recordEnd - this.recordStart) / 1000)
      this.recording = false

      clearInterval(this.recordInterval)
      this.recordInterval = null
    },
    cancelRecord () {
      this.cancelRecording()
      this.recording = false

      clearInterval(this.recordInterval)
      this.recordInterval = null
    },
    formatNumber (number) {
      if (number < 10)
        return `0${number}`

      return number
    }
  },
  watch: {
    chat () {
      const messages = this.$refs['chat-messages']

      if (messages) {
        const space = messages.scrollHeight - (messages.offsetHeight * 1.25)

        if (space < messages.scrollTop || this.sentByMe) {
          messages.scrollTop = messages.scrollHeight

          if (this.sentByMe)
            this.sentByMe = false
        }
      }
    }
  },
  mounted () {
    this.$refs['chat-messages'].scrollTop = this.$refs['chat-messages'].scrollHeight
  },
  beforeDestroy () {
    if (this.recordInterval)
      clearInterval(this.recordInterval)
  }
}
</script>

<style lang="scss" scoped>
.chat {
  padding: 0 10px 10px 10px;
  flex-basis: 26vw;
  min-width: 450px;
  max-height: 100%;
  &.chat--padding {
    padding-top: 77px;
  }
  &__box {
    margin: 0 15px;
    padding: 10px;
    width: calc(100% - 35px);
    height: 100%;
    background-color: #bbb;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    &__messages {
      max-height: 100%;
      overflow-y: auto;
    }
    &__form {
      padding: 5px;
      padding-right: 0;
      margin-top: 5px;
      textarea {
        font-family: 'Volte', sans-serif;
        resize: none;
        padding: 10px;
        flex: 1;
      }
      button {
        margin-left: 5px;
        width: 40px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0;
        svg {
          font-size: 20px
        }
      }
      span {
        flex: 1;
        text-align: center;
        margin: auto;
      }
      &__cancel {
        margin-right: 5px;
      }
    }
  }
}

@media screen and (max-width: 800px) {
  .chat {
    padding: 0 10px;
    flex-basis: 26vw;
    min-width: 100%;
    max-height: 35vh;
    &__box {
      margin: 0;
      width: 100%;
    }

    &.chat--padding {
      padding: 0 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ChatBox/index.vue